import {
    CSV_DEFAULT_EMPTY_VALUE,
    CSV_ESCAPED_DOUBLE_QUOTE_PATTERN,
    CSV_QUOTE_CHARACTER,
    CSV_SURROUNDING_QUOTE_PATTERN,
} from './constants';

export const formatCsvField = (value: string | null | undefined, emptyValue: string) => {
    const trimmed = value?.trim() ?? '';
    return trimmed ? trimmed : emptyValue;
};

export const isCsvEmptyValue = (value: string | undefined, emptyValue: string) => {
    const trimmed = value?.trim() ?? '';
    return !trimmed || trimmed.toLowerCase() === emptyValue.toLowerCase();
};

export const createCsvFieldHelpers = (emptyValue = CSV_DEFAULT_EMPTY_VALUE) => ({
    emptyValue,
    formatField: (value: string | null | undefined) => formatCsvField(value, emptyValue),
    isEmpty: (value: string | undefined) => isCsvEmptyValue(value, emptyValue),
});

const unescapeCsvDoubleQuotes = (value: string): string =>
    value.replace(CSV_ESCAPED_DOUBLE_QUOTE_PATTERN, CSV_QUOTE_CHARACTER);

export const normalizeCaretCsvField = (value: string | undefined): string => {
    const trimmed = value?.trim() ?? '';
    return unescapeCsvDoubleQuotes(trimmed.replace(CSV_SURROUNDING_QUOTE_PATTERN, ''));
};

/** Unwraps a caret-delimited row when the exporter wrapped it in CSV quotes (e.g. fields contain commas). */
export const unquoteCaretCsvLine = (rawLine: string): string => {
    const trimmed = rawLine.trim();

    if (trimmed.length >= 2 && trimmed.startsWith(CSV_QUOTE_CHARACTER) && trimmed.endsWith(CSV_QUOTE_CHARACTER)) {
        return unescapeCsvDoubleQuotes(trimmed.slice(1, -1));
    }

    return trimmed;
};

export const parseCaretCsvFields = (rawLine: string, delimiter: string): string[] =>
    unquoteCaretCsvLine(rawLine).split(delimiter).map(normalizeCaretCsvField);
